import React from 'react'
import Orders from './list/ListOrders.page';

function OnlineOrdersPage() {
	return (
		<Orders
			title="طلبات اونلاين"
			fixedFilters={{
				is_cashier: false,
			}}
		/>
	);
}

export default OnlineOrdersPage;